var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray"},[_c('navigation-bar'),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('h1',{staticClass:"text-left",staticStyle:{"margin-top":"20px"}},[_vm._v("Confirm Email")]),_vm._v(" "),_c('p',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.store.state.message))])]),_vm._v(" "),_c('dashboard-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1472a7ab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/ConfirmEmail.vue
// module id = null
// module chunks = 